import { api } from "@shared/lib/api";
import { BackednResponse } from "@shared/lib/types";
import { IAIConfiguration } from "../types";

export class AIService {
  static async getGenAIConfiguration(briefId: string) {
    const url = "genai/configuration";
    const params = new URLSearchParams();
    if (briefId) {
      params.append("briefId", briefId);
    }
    const query = params.toString();
    const fullUrl = `${url}${query ? "?" + query : ""}`;
    return (await api.get(fullUrl).json()) as BackednResponse<IAIConfiguration>;
  }
}
